export type RelativeTimeUnit = 'now' | 'minutes' | 'hours' | 'days';

export type RelativeTimeParts = {
    count: number;
    unit: RelativeTimeUnit;
};

const MILLISECONDS_PER_SECOND = 1000;
const SECONDS_PER_MINUTE = 60;
const MINUTES_PER_HOUR = 60;
const HOURS_PER_DAY = 24;

const getRelativeTimeParts = ({ from, to }: { from: Date; to: Date }): RelativeTimeParts => {
    const elapsedSeconds = Math.max(
        0,
        Math.floor((to.getTime() - new Date(from).getTime()) / MILLISECONDS_PER_SECOND)
    );
    const elapsedMinutes = Math.floor(elapsedSeconds / SECONDS_PER_MINUTE);
    const elapsedHours = Math.floor(elapsedMinutes / MINUTES_PER_HOUR);
    const elapsedDays = Math.floor(elapsedHours / HOURS_PER_DAY);

    if (elapsedMinutes < 1) {
        return { count: 0, unit: 'now' };
    }

    if (elapsedMinutes < MINUTES_PER_HOUR) {
        return { count: elapsedMinutes, unit: 'minutes' };
    }

    if (elapsedHours < HOURS_PER_DAY) {
        return { count: elapsedHours, unit: 'hours' };
    }

    return { count: elapsedDays, unit: 'days' };
};

export default getRelativeTimeParts;
